// extracted by mini-css-extract-plugin
module.exports = {"container":"ShipmentTracking_container__2DCtq"};